export const GET_CLIENTS_LIST = "GET_CLIENTS_LIST";

export const getClientsList = () => {
  return { type: GET_CLIENTS_LIST };
};



// WEBPACK FOOTER //
// src/redux/actions/clientsActions.js